import React from "react";
import { Container } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ProductSection from "../components/ProductSection";
import { PRODUCT_CATEGORIES, getProductsByCategory } from "../data/products";
import "./PricingPage.css";

const PricingPage = () => {
  const dedicated = getProductsByCategory(PRODUCT_CATEGORIES.DEDICATED);
  const cloud = getProductsByCategory(PRODUCT_CATEGORIES.CLOUD);
  const devop = getProductsByCategory(PRODUCT_CATEGORIES.DEVOP);
  const remoteDesktop = getProductsByCategory(PRODUCT_CATEGORIES.REMOTE_DESKTOP);

  return (
    <>
      <Navbar />
      <main className="hn-pricing-main">
        <section className="hn-pricing-hero">
          <Container>
            <h1 className="hn-pricing-title">Pricing</h1>
            <p className="hn-pricing-intro">
              All plans in one place. Compare dedicated instances, cloud processing, DevOps services, and remote desktop. Transparent pricing, no hidden fees.
            </p>
          </Container>
        </section>
        <ProductSection category="dedicated" products={dedicated} />
        <ProductSection category="cloud" products={cloud} />
        <ProductSection category="devop" products={devop} />
        <ProductSection category="remote" products={remoteDesktop} />
      </main>
      <Footer />
    </>
  );
};

export default PricingPage;
